import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import { Modal } from 'react-bootstrap';
import '../css/Admin_css/admin-customize.css';
import myToast from '../Utils/MyToast';
import { FaTrashAlt, FaDatabase, FaExclamationTriangle, FaTable } from 'react-icons/fa';

const MODAL_RADIUS = 16;

const DEL_STYLES = `
  .mdl-del-exam.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.5rem auto 1.25rem;
    max-width: 640px;
  }
  .mdl-del-exam .modal-content {
    z-index: 1051 !important;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    border: 1.5px solid #fecaca;
    box-shadow: 0 16px 40px rgba(220, 38, 38, 0.12);
    background: #fff;
  }
  .mdl-del-exam .modal-header {
    border: none;
    padding: 18px 22px 16px;
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 55%, #991b1b 100%);
  }
  .mdl-del-exam .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.6rem;
    font-weight: 400;
  }
  .mdl-del-exam .modal-body {
    padding: 18px 20px 12px;
    background:
      radial-gradient(ellipse at top right, rgba(254,202,202,0.35), transparent 42%),
      linear-gradient(180deg, #fffbfb 0%, #ffffff 48%);
  }
  .mdl-del-exam .modal-footer {
    border-top: 1px solid #fee2e2;
    padding: 12px 20px;
    background: #fef2f2;
  }
  .mde-title {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 24px;
  }
  .mde-title__icon {
    width: 36px; height: 36px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mde-title__text { min-width: 0; display: flex; flex-direction: column; gap: 2px; }
  .mde-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mde-title__exam { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.95); }
  .mde-title__hint { font-size: 11px; font-weight: 500; color: rgba(255,255,255,0.84); line-height: 1.3; }

  .mde-warning {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 14px;
    border-radius: 10px;
    background: #fef3c7;
    border: 1.5px solid #fcd34d;
    margin-bottom: 16px;
  }
  .mde-warning__icon { color: #d97706; font-size: 18px; flex-shrink: 0; }
  .mde-warning__text { font-size: 12px; font-weight: 600; color: #92400e; line-height: 1.4; }

  .mde-section-label {
    display: flex; align-items: center; gap: 6px;
    margin: 0 0 8px;
    font-size: 10px; font-weight: 800;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #dc2626;
  }
  .mde-section-label span {
    margin-left: auto;
    font-size: 10px; font-weight: 700;
    letter-spacing: 0; text-transform: none;
    color: #64748b; background: #fee2e2;
    border: 1px solid #fecaca; border-radius: 999px;
    padding: 1px 7px;
  }

  .mde-records {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 8px;
    margin-bottom: 14px;
  }
  @keyframes mde-fadeIn {
    from { opacity: 0; transform: translateY(6px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .mde-record {
    display: flex; align-items: center; gap: 10px;
    padding: 10px 12px;
    border-radius: 10px;
    border: 1.5px solid #f1f5f9;
    background: #fff;
    transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
    animation: mde-fadeIn .3s ease both;
  }
  .mde-record:hover { border-color: #fca5a5; box-shadow: 0 2px 10px rgba(220,38,38,.06); background: #fffbfb; }
  .mde-record__icon {
    width: 28px; height: 28px;
    border-radius: 8px;
    display: inline-flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    font-size: 11px;
    color: #dc2626;
    background: linear-gradient(135deg, #fef2f2, #fff5f5);
    border: 1px solid #fecaca;
  }
  .mde-record__info { flex: 1; min-width: 0; }
  .mde-record__name {
    font-size: 12px; font-weight: 700; color: #1e293b;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    line-height: 1.3;
  }
  .mde-record__table {
    font-size: 10px; font-weight: 600; color: #a0aec0;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
    font-family: 'Courier New', monospace;
  }
  .mde-record__count {
    flex-shrink: 0;
    font-size: 13px; font-weight: 800;
    color: #fff;
    min-width: 28px; text-align: center;
    background: #ef4444;
    border-radius: 7px;
    padding: 2px 8px;
    line-height: 1.4;
  }
  .mde-record__count--zero { background: #e2e8f0; color: #94a3b8; }

  .mde-total {
    display: flex; align-items: center; justify-content: space-between;
    padding: 10px 14px;
    border-radius: 10px;
    background: linear-gradient(135deg, #fef2f2 0%, #fff5f5 100%);
    border: 1.5px solid #fecaca;
    margin-bottom: 4px;
  }
  .mde-total__label { font-size: 12px; font-weight: 800; color: #991b1b; }
  .mde-total__value {
    font-size: 20px; font-weight: 900; color: #dc2626;
    letter-spacing: -.02em;
  }

  .mde-btn {
    display: inline-flex; align-items: center; justify-content: center;
    gap: 6px; min-height: 34px; padding: 6px 14px;
    border-radius: 8px; font-size: 12px; font-weight: 800;
    cursor: pointer; border: 1.5px solid transparent;
    transition: background .15s, border-color .15s, transform .12s;
  }
  .mde-btn:disabled { opacity: 0.65; cursor: not-allowed; }
  .mde-btn--ghost {
    background: #fff; border-color: #cbd5e1; color: #475569; margin-right: 8px;
  }
  .mde-btn--ghost:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
  .mde-btn--danger {
    background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    border-color: #dc2626; color: #fff;
    box-shadow: 0 4px 12px rgba(220,38,38,0.28);
  }
  .mde-btn--danger:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(220,38,38,0.34); }
`;

const MdlDeleteExamConfirmation = ({ actionClose, actionConfirm, exam_id, session_id, exam_name }) => {
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);

  const fetchRecords = useCallback(() => {
    setLoading(true);
    const URL = process.env.REACT_APP_SERVER_NAME + process.env.REACT_APP_TARGET_DIR + 'getExamDependentRecord.php';
    axios.get(URL, { params: { exam_id, session_id, school_code: SessionManager.getSchoolCode() } })
      .then(res => res.data)
      .then(response => {
        setLoading(false);
        if (response.api_status === 'OK') {
          setRecords(response.data || []);
        } else {
          myToast.notify_warning(response.api_remark || 'Unable to load dependent records');
        }
      })
      .catch(() => { setLoading(false); });
  }, [exam_id, session_id]);

  useEffect(() => { fetchRecords(); }, [fetchRecords]);

  const totalRecords = records.reduce((sum, r) => sum + (parseInt(r.records, 10) || 0), 0);

  const handleClose = useCallback(() => {
    if (actionClose) actionClose();
  }, [actionClose]);

  return (
    <div>
      <style>{DEL_STYLES}</style>
      <Modal
        show
        onHide={handleClose}
        animation={false}
        size="lg"
        dialogClassName="mdl-del-exam"
        centered
        backdrop="static"
        enforceFocus={false}
        restoreFocus={false}
      >
        <Modal.Header closeButton>
          <div className="mde-title">
            <span className="mde-title__icon" aria-hidden><FaTrashAlt /></span>
            <div className="mde-title__text">
              <div className="mde-title__main">Delete Exam</div>
              <div className="mde-title__exam">{exam_name}</div>
              <div className="mde-title__hint">This action is permanent and cannot be undone</div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <div style={{ minHeight: 180, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MyLoader />
            </div>
          ) : (
            <>
              <div className="mde-warning">
                <FaExclamationTriangle className="mde-warning__icon" />
                <div className="mde-warning__text">
                  All data listed below will be permanently deleted along with exam "<strong>{exam_name}</strong>". Backups will be created automatically before deletion.
                </div>
              </div>

              <p className="mde-section-label">
                <FaDatabase style={{ fontSize: 11 }} />
                Dependent Tables &amp; Records
                <span>{records.length} tables</span>
              </p>

              <div className="mde-records">
                {records.map((item, index) => {
                  const count = parseInt(item.records, 10) || 0;
                  return (
                    <div className="mde-record" key={index} style={{ animationDelay: `${index * 50}ms` }}>
                      <span className="mde-record__icon" aria-hidden><FaTable /></span>
                      <div className="mde-record__info">
                        <div className="mde-record__name">{item.table_caption}</div>
                      </div>
                      <div className={`mde-record__count${count === 0 ? ' mde-record__count--zero' : ''}`}>
                        {count}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="mde-total">
                <span className="mde-total__label">Total records to be deleted</span>
                <span className="mde-total__value">{totalRecords}</span>
              </div>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="mde-btn mde-btn--ghost" onClick={handleClose}>
            Cancel
          </button>
          <button
            type="button"
            className="mde-btn mde-btn--danger"
            onClick={actionConfirm}
            disabled={loading}
          >
            <FaTrashAlt style={{ fontSize: 11 }} />
            Confirm Delete
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MdlDeleteExamConfirmation;
